<template>
  <cus-order-dialog>
    <template v-slot:body>
      <div class="shift-wrap">
        <div class="form-item">
          <span>系統日期</span>
          <span>{{ formatDateTime('YYYY/MM/DD', getSystem?.date) }}</span>
        </div>
        <div class="form-item">
          <span>機台</span>
          <span>{{ getSystem?.client_id }}</span>
        </div>
        <div class="form-item">
          <span>班別</span>
          <span>{{ getSystem?.section }}</span>
        </div>
        <div class="form-item">
          <span>實際抽屜現金</span>
          <div :class="['input-button', cashBox ? 'done' : '']" @click="openInput($event, 'inputCashBox')">
            <p>{{ cashBox || '請輸入抽屜現金' }}</p>
            <i
              data-action="cancel"
              v-if="cashBox"
              class="bi bi-x-circle-fill action-icon icon"
              @click="cashBox = ''"
            ></i>
          </div>
        </div>
        <div class="form-item">
          <span>雜支</span>
          <div :class="['input-button', cost.length !== 0 ? 'done' : '']" @click="openInput($event, 'costList')">
            <p>
              {{
                cost.length !== 0
                  ? cost.reduce(function (total, e) {
                      return total + e.amount;
                    }, 0)
                  : '請輸入雜支'
              }}
            </p>
            <i
              data-action="cancel"
              v-if="cost.length !== 0"
              class="bi bi-x-circle-fill action-icon icon"
              @click="cost = []"
            ></i>
          </div>
        </div>
        <div class="form-item">
          <span>帳號</span>
          <cus-input v-model:value="account" placeholder="請輸入帳號" :errorText="errorText.account"></cus-input>
        </div>
        <div class="form-item">
          <span>密碼</span>
          <cus-input
            v-model:value="password"
            placeholder="請輸入密碼"
            :errorText="errorText.password"
            type="password"
          ></cus-input>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button
          v-if="getSystem?.show_alert_type !== 2"
          text="取消"
          color="white"
          :width="50"
          @click="close"
        ></cus-button>
        <cus-button
          text="交班清帳"
          color="blue"
          :width="getSystem?.show_alert_type !== 2 ? 50 : 100"
          :disabled="!account || !password"
          @click="handleShift"
        ></cus-button>
      </div>
    </template>
  </cus-order-dialog>

  <!-- 各式彈窗 -->
  <component :is="dialogTemplate"></component>
  <component :is="inner_dialogTemplate"></component>
</template>
<script>
import { ref, inject, reactive, defineAsyncComponent, getCurrentInstance } from 'vue';
import { useDialog, useDialogInDialog } from '@/utils/dialog';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import { formatDateTime } from '@/utils/datetime';
export default {
  name: 'shift',
  components: {
    Computer: defineAsyncComponent(() => import('@/components/dialog/Computer.vue')),
    CostList: defineAsyncComponent(() => import('@/components/orderDialog/CostList.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const { dialogTemplate, openHeaderDialog, closeDialog } = useDialog();
    const { inner_dialogTemplate, openInnerDialog, closeInnerDialog } = useDialogInDialog();
    //接受provide值
    const close = inject('order_close');
    const openOrderDialog = inject('openOrderDialog');
    const controlCloseButton = inject('order_controlCloseButton');
    //如果是強制清帳，必須把叉叉關掉
    const getSystem = useGetters('system', ['getSystem']);
    if (getSystem.value?.show_alert_type === 2) {
      controlCloseButton(true);
    }
    //建立參數
    const cashBox = ref('');
    const cost = ref([]);
    const account = ref('');
    const password = ref('');
    let errorText = reactive({
      account: '',
      password: '',
    });
    //取得班號
    const doGetDutySection = useActions('system', ['doGetDutySection']);
    const SET_SHOW_SHIFT = useMutations('accounting', ['SET_SHOW_SHIFT']);
    const init = (async function () {
      await doGetDutySection();
      SET_SHOW_SHIFT(false);
    })();
    //打開彈窗
    const openInput = (e, type) => {
      if (e.target.getAttribute('data-action') === 'cancel') return;
      if (type === 'inputCashBox') openHeaderDialog(type);
      else if (type === 'costList') openInnerDialog(type);
    };
    //輸入實際抽屜金額
    const handleCashBox = (val) => {
      cashBox.value = Number(val);
      closeDialog();
    };
    //輸入雜支
    const handleCostList = (val) => {
      cost.value = val;
      closeInnerDialog();
    };
    //交班清帳
    const doShift = useActions('accounting', ['doShift']);
    const handleShift = async () => {
      const data = {
        account: account.value,
        password: password.value,
        cash_box: cashBox.value,
        other_expense: [],
      };
      cost.value.forEach((e) => {
        data.other_expense.push({ name: e.category + '：' + e.name, amount: e.amount });
      });
      const res = await doShift(data);
      if (res.error_message) {
        proxy
          .$confirm({
            title: '週邊設備連線異常，請確認！',
            image: require('@/assets/images/icon-notice.png'),
            content: res.error_message,
            confirmText: '再試一次',
            confirmColor: 'blue',
            confirm2Text: '略過',
            moreConfirm: true,
          })
          .then((val) => {
            if (val === '再試一次') {
              handleShift();
            } else if (val === '略過') {
              openOrderDialog('squareRecord');
            }
          })
          .catch((e) => e);
      } else {
        openOrderDialog('squareRecord');
      }
    };
    return {
      formatDateTime,
      dialogTemplate,
      inner_dialogTemplate,
      close,
      cashBox,
      cost,
      account,
      password,
      errorText,
      getSystem,
      init,
      openInput,
      handleCashBox,
      handleCostList,
      handleShift,
    };
  },
};
</script>
<style lang="scss" scoped>
.shift-wrap {
  display: grid;
  grid-template-rows: repeat(3, 40px) repeat(3, 1fr);
}
.form-item {
  display: grid;
  grid-template-columns: 130px auto;
  align-items: center;
  span {
    font-size: 2rem;
    padding-left: 10px;
    color: $color-gray-60;
    margin-bottom: 12px;
  }
  span:nth-child(2) {
    color: $color-blue;
    font-size: 2.2rem;
  }
}
.input-button {
  @include input-basic;
  position: relative;
  height: $input-height;
  color: $color-gray-60;
  cursor: pointer;
}
.done {
  color: $color-blue;
}
.icon {
  font-size: 2.2rem;
  color: $color-gray-30;
}
</style>
